import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Truck, RefreshCw, Instagram, Facebook, Twitter, Headphones } from "lucide-react";

const COLS = [
  ["Shop", [["Perfumes", "/shop?category=Perfumes"], ["Air Fresheners", "/shop?subcategory=Air%20Fresheners"], ["Skincare", "/shop?category=Skincare"], ["Soaps", "/shop?category=Soaps"], ["Best Sellers", "/shop?best=1"], ["New Arrivals", "/shop?new=1"]]],
  ["Customer Service", [["Shipping & Returns", "/shipping-returns"], ["FAQ", "/faq"], ["Contact Us", "/contact"], ["My Account", "/account"], ["Track Order", "/account?tab=orders"]]],
  ["Company", [["About Us", "/about"], ["Contact", "/contact"], ["Privacy Policy", "/privacy"], ["Terms & Conditions", "/terms"]]],
];

export default function Footer() {
  const subscribe = (e) => {
    e.preventDefault();
    e.target.reset();
    toast.success("Welcome to the Royal Club — your sample kit is on its way");
  };
  return (
    <footer className="bg-[#0B0B0C] border-t border-[rgba(212,175,55,0.18)] mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 py-10 border-b border-[rgba(212,175,55,0.12)]">
          {[[ShieldCheck, "Authentic Guarantee", "100% genuine perfumes"], [Truck, "Complimentary Shipping", "On orders over $150"], [RefreshCw, "30-Day Returns", "Elegant, hassle-free"], [Headphones, "Customer Support", "7 days a week"]].map(([Icon, t, s], i) => (
            <div key={i} className="flex items-center gap-3 justify-center sm:justify-start">
              <Icon className="text-[#D4AF37] shrink-0" size={22} />
              <div>
                <p className="text-sm text-[#FAFAF7]">{t}</p>
                <p className="text-xs text-[#FAFAF7]/50">{s}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 py-14">
          <div className="col-span-2">
            <h4 className="font-serif-lux text-2xl gold-text mb-3">QUEEN MJ MAISON BEAUTE</h4>
            <p className="text-sm text-[#FAFAF7]/50 leading-relaxed max-w-xs">A premium fragrance destination for elegant perfumes and beautiful home fragrance, composed for those who wear elegance as a second skin.</p>
            <div className="flex gap-4 mt-5">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="text-[#FAFAF7]/50 hover:text-[#D4AF37] transition-colors"><Instagram size={18} /></a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="social-facebook" className="text-[#FAFAF7]/50 hover:text-[#D4AF37] transition-colors"><Facebook size={18} /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" data-testid="social-twitter" className="text-[#FAFAF7]/50 hover:text-[#D4AF37] transition-colors"><Twitter size={18} /></a>
            </div>
          </div>
          {COLS.map(([title, links]) => (
            <div key={title}>
              <p className="eyebrow mb-4">{title}</p>
              <ul className="space-y-2.5 text-sm text-[#FAFAF7]/60">
                {links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="hover:text-[#D4AF37] transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-[rgba(212,175,55,0.12)] py-10">
          <div className="max-w-md">
            <p className="eyebrow mb-3">Royal Club Newsletter</p>
            <p className="text-sm text-[#FAFAF7]/50 mb-3">Join for early access, private launches & a complimentary sample kit.</p>
            <form onSubmit={subscribe} className="flex gap-2">
              <input required type="email" data-testid="newsletter-input" placeholder="Your email" className="flex-1 bg-transparent gold-border rounded-full px-4 py-2.5 text-sm text-[#FAFAF7] outline-none focus:border-[#D4AF37]" />
              <button data-testid="newsletter-submit" className="btn-gold px-6 py-2.5 rounded-full text-xs">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-[#FAFAF7]/40 border-t border-[rgba(212,175,55,0.1)]">
          <span>© {new Date().getFullYear()} Queen MJ Maison Beaute. All rights reserved.</span>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-[#D4AF37]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#D4AF37]">Terms</Link>
            <Link to="/shipping-returns" className="hover:text-[#D4AF37]">Shipping</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
